import { useRef, useEffect } from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'

const useVideoEnable = () => {
    const { videoTrack } = useVideoContext()
    const videoRef = useRef(null)
    let videoElement = videoRef.current

    useEffect(() => {
        if (videoTrack && videoElement) {
            videoTrack.attach(videoElement)
        }

        return () => {
            if (videoTrack && videoElement) {
                videoTrack.detach(videoElement)
                videoElement = null
            }
        }
    }, [videoTrack, videoElement])

    const isVideoEnable = videoTrack?.isEnabled

    return [videoRef, isVideoEnable]
}

export default useVideoEnable
